import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Absence } from '@qaroni-app/absences/types/absence';

@Component({
  selector: 'qaroni-absence-type-details',
  templateUrl: './absence-type-details.component.html',
  styleUrl: './absence-type-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsenceTypeDetailsComponent {
  readonly absence = input<Absence | null | undefined>(null);

  get hasDetails(): boolean {
    return !!this.absence()?.timeMax || !!this.absence()?.hasApproval;
  }
}
